import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = ({ variant = 'default', showLabel = true, size = 'medium' }) => {
  const { toggleTheme, isDark } = useTheme();

  const getVariantClass = () => {
    switch (variant) {
      case 'navbar': return 'theme-toggle-navbar';
      case 'sidebar': return 'theme-toggle-sidebar';
      case 'floating': return 'theme-toggle-floating';
      default: return 'theme-toggle-default';
    }
  };

  const getSizeClass = () => {
    switch (size) {
      case 'small': return 'theme-toggle-sm';
      case 'large': return 'theme-toggle-lg';
      default: return 'theme-toggle-md';
    }
  };

  return (
    <div className={`theme-toggle ${getVariantClass()} ${getSizeClass()}`}>
      {showLabel && (
        <span className="theme-toggle-label">
          <i className={`bi ${isDark ? 'bi-moon-stars' : 'bi-sun'} me-2`}></i>
          {isDark ? 'Dark' : 'Light'} Mode
        </span>
      )}
      
      <button
        className={`theme-toggle-button ${isDark ? 'dark' : 'light'}`}
        onClick={toggleTheme}
        title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      >
        <div className="toggle-track">
          <div className="toggle-thumb">
            <i className={`bi ${isDark ? 'bi-moon-stars' : 'bi-sun'}`}></i>
          </div>
        </div>
      </button>
      
      {variant === 'floating' && (
        <div className="theme-toggle-tooltip">
          {isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        </div>
      )}
    </div>
  );
};

export default ThemeToggle;